import { Box, Button, Cards, Container, Header, SpaceBetween } from '@cloudscape-design/components'
import { FC } from 'react'

type GkeOrNonGkeProps = {
  onOnboardPlatform: () => void
  onContinue: () => void
  isLoading?: boolean
}

const GkeOrNonGke: FC<GkeOrNonGkeProps> = ({
  onOnboardPlatform,
  onContinue,
  isLoading = false
}) => {
  const targetOptions = [
    {
      id: 'new-gke-cluster',
      title: 'Onboard a new GKE Cluster',
      eyebrow: 'Recommended when no cluster exists',
      description:
        'Create the workload cluster first so application owner and tag defaults can be inherited from approved infrastructure.',
      actionLabel: 'Start Cluster Onboarding',
      action: onOnboardPlatform,
      actionVariant: 'primary' as const
    },
    {
      id: 'existing-target',
      title: 'Continue to Application Onboarding',
      eyebrow: 'Use an approved or non-GKE target',
      description:
        'Proceed when you can select an existing GKE cluster, reuse an approved platform, or onboard for standalone GCP infrastructure.',
      actionLabel: 'Continue',
      action: onContinue,
      actionVariant: 'normal' as const
    }
  ]

  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Choose the starting point that matches the infrastructure your application will use."
        >
          Application Onboarding
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        <Box variant="p" color="text-body-secondary">
          Start with cluster onboarding when no GKE target exists yet. Continue
          here when you already have an approved cluster, an existing platform,
          or a non-GKE target ready for application onboarding.
        </Box>

        <Cards
          items={targetOptions}
          cardsPerRow={[
            { cards: 1 },
            { minWidth: 500, cards: 2 }
          ]}
          cardDefinition={{
            header: (item) => (
              <SpaceBetween direction="vertical" size="xs">
                <Box color="text-label">{item.eyebrow}</Box>
                <Header variant="h3">{item.title}</Header>
              </SpaceBetween>
            ),
            sections: [
              {
                id: 'description',
                content: (item) => (
                  <SpaceBetween direction="vertical" size="m">
                    <Box variant="p" color="text-body-secondary">
                      {item.description}
                    </Box>
                    <Button
                      variant={item.actionVariant}
                      onClick={item.action}
                      loading={isLoading}
                    >
                      {item.actionLabel}
                    </Button>
                  </SpaceBetween>
                )
              }
            ]
          }}
          trackBy="id"
        />
      </SpaceBetween>
    </Container>
  )
}

export default GkeOrNonGke
